import { render, staticRenderFns } from "./ForgotPwd.vue?vue&type=template&id=2f48e7fd"
import script from "./ForgotPwd.vue?vue&type=script&lang=js"
export * from "./ForgotPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports